module.exports = __webpack_public_path__ + "img/article_8_3.636ad8a4.jpg";